/* redesign-simple.js — the simple product page (sections/redesign-product-simple).
   Loaded behind rd_simple only. Two jobs:

   1. Variant pills. A radio per variant; picking one rewrites the hidden `id`
      the form posts, the price, the struck compare-at and — on the gift card —
      the amount drawn on the card art.
   2. Add to cart through the shared drawer engine. redesign.js exposes
      window.rdCart.add(payload); it posts, re-renders the drawer from the
      section the response carries, and opens it. If the engine is absent the
      form is left alone and posts natively to /cart/add, which is what it
      does with scripting off anyway. There is exactly one implementation of
      "add a line without a reload" on this site and this is a client of it,
      not a second copy — see cart-engine-is-shared. */
(function () {
  var root = document.querySelector('[data-rd-simple]');
  if (!root) return;

  var form = root.querySelector('[data-rd-simple-form]');
  var idInput = form && form.querySelector('input[name="id"]');
  var priceEl = root.querySelector('[data-rd-simple-price]');
  var wasEl = root.querySelector('[data-rd-simple-was]');
  var amountEls = root.querySelectorAll('[data-rd-simple-amount]');
  var btn = form && form.querySelector('[data-rd-simple-atc]');
  var errEl = form && form.querySelector('[data-rd-simple-error]');

  root.addEventListener('change', function (e) {
    var r = e.target.closest('input[name="rd-simple-variant"]');
    if (!r) return;
    if (idInput) idInput.value = r.value;
    if (priceEl && r.dataset.price) priceEl.textContent = r.dataset.price;
    if (wasEl) {
      if (r.dataset.was) { wasEl.textContent = r.dataset.was; wasEl.hidden = false; }
      else wasEl.hidden = true;
    }
    for (var i = 0; i < amountEls.length; i++) amountEls[i].textContent = r.dataset.price;
    if (btn) {
      var ok = r.dataset.available === 'true';
      btn.disabled = !ok;
      btn.textContent = ok ? btn.dataset.label : btn.dataset.soldout;
    }
  });

  if (!form) return;
  form.addEventListener('submit', function (e) {
    if (!window.rdCart || !idInput) return;
    e.preventDefault();
    if (!btn || btn.classList.contains('is-busy') || btn.disabled) return;
    btn.classList.add('is-busy');
    if (errEl) errEl.hidden = true;
    window.rdCart.add({ id: Number(idInput.value), quantity: 1 }).then(function () {
      btn.classList.remove('is-busy');
    }).catch(function (err) {
      btn.classList.remove('is-busy');
      if (errEl) { errEl.textContent = err && err.message ? err.message : 'Could not add to cart.'; errEl.hidden = false; }
    });
  });
})();
